import SApiAxios from '../helpers/ApiAxios';

export {
  SApiAxios
}